import { render, staticRenderFns } from "./AscPlotListWrapper.vue?vue&type=template&id=0821a104&"
import script from "./AscPlotListWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotListWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports